import {resolveRoute} from '../helpers/ajax'
import type { DataTableDefaultRenderer, DataTableProps} from '../components/datatable';
import {DataTable} from '../components/datatable'
import {renderFragment} from '../helpers/react-helpers'
import React from 'react'
import {InternalLink} from '../components/external-links'
import {NotSet} from '../components/table-links'

const PackageLink: DataTableDefaultRenderer<any> = ({data, row, meta, children}) => {
    const style = {
        maxWidth: meta.columnSettings.maxWidth,
        minWidth: meta.columnSettings.minWidth,
        width: meta.columnSettings.width,
    }
    return <InternalLink route="packages.edit"
        params={{id: row.id}}
        className="ellipsis"
        style={{...style, maxWidth: meta.columnSettings.maxWidth ?? meta.columnSettings.width}}>{children ||
        <NotSet />}</InternalLink>
}


export default function() {
    const config: DataTableProps = {
        ajax: {
            url: resolveRoute('packages.dataTable'),
        },
        defaultRender: PackageLink,
        columns: [
            {
                title: "Name",
                data: 'name',
                className: 'tleft',
            },
            {
                title: "Vehicles",
                data: 'vehicles',
            },
            {
                title: "Price Range",
                data: 'price_range',

                render: ({data: price_range, row}) => {
                    if(!price_range) {
                        return <InternalLink route="packages.edit" params={{id: row.id}}>N/A</InternalLink>
                    }
                    if(price_range[0] == price_range[1]) {
                        return <InternalLink route="packages.edit" params={{id: row.id}}>{price_range[0]}</InternalLink>
                    }
                    return <InternalLink route="packages.edit"
                        params={{id: row.id}}>{price_range[0]} &ndash; {price_range[1]}</InternalLink>
                },
            }
        ],
        storageKey: 'packages_index',
        order: [
            ['name','asc'],
        ],
    }

    renderFragment(<DataTable {...config} />, '#packages-table')
}
